export enum CancellationType {
  Appointment,
  Visit,
}
